export const KEY_CODES = {
  ENTER: 13,
  ESCAPE: 27,
};

export default KEY_CODES;
